import { useFormik } from 'formik'
import { TFuncKey, useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { UseLogReturnedPaymentFormProps } from './useLogReturnedPaymentForm.types'

const reasons: { code: string; label: TFuncKey }[] = [
  { code: 'AccountInvalid', label: 'paymentReturn.reason.accountInvalid' },
  { code: 'AccountBlocked', label: 'paymentReturn.reason.accountBlocked' },
  { code: 'AccountClosed', label: 'paymentReturn.reason.accountClosed' },
  { code: 'BeneficiaryDetailsIncorrect', label: 'paymentReturn.reason.beneficiaryDetailsIncorrect' },
  { code: 'BeneficiaryRefused', label: 'paymentReturn.reason.beneficiaryRefused' },
  { code: 'InsufficientFunds', label: 'paymentReturn.reason.insufficientFunds' },
  { code: 'RegulatoryOrCompliance', label: 'paymentReturn.reason.regulatoryOrCompliance' },
  { code: 'FormatOrTechnical', label: 'paymentReturn.reason.formatOrTechnical' },
  { code: 'DuplicateOrError', label: 'paymentReturn.reason.duplicateOrError' },
  { code: 'TimingOrExpiry', label: 'paymentReturn.reason.timingOrExpiry' },
  { code: 'Other', label: 'paymentReturn.reason.other' }
]

export function useLogReturnedPaymentForm({ onFormSubmit }: UseLogReturnedPaymentFormProps) {
  const { t } = useTranslation()

  const formik = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {
      returnReason: 'AccountInvalid',
      customReason: ''
    },
    validationSchema: () =>
      Yup.object().shape({
        returnReason: Yup.string()
          .oneOf(reasons.map(r => r.code))
          .required(t('errorMessage.required')),
        customReason: Yup.string()
          .nullable()
          .optional()
          .when('returnReason', {
            is: 'Other',
            then: Yup.string()
              .required(t('paymentReturn.customReason.required'))
              .trim()
              .min(1, t('errorMessage.orgFieldCharacterLimit', { fieldName: 'Custom reason' }))
              .max(255, t('errorMessage.orgFieldCharacterLimit', { fieldName: 'Custom reason' }))
          })
      }),
    onSubmit: async ({ returnReason, customReason }) => {
      const reason = returnReason === 'Other' ? customReason : returnReason

      await onFormSubmit({
        reason
      })
    }
  })

  return {
    formik,
    reasons,
    reasonOptions: reasons.map(reason => ({
      label: t(reason.label),
      value: reason.code
    }))
  }
}
